import {
  defaultDropAnimationSideEffects,
  DragOverlay,
  DropAnimation,
} from '@dnd-kit/core';
import { snapCenterToCursor } from '@dnd-kit/modifiers';
import React from 'react';
import { index, Options } from 'shared/assets/styles';

const centerUnderMouseModifier = [snapCenterToCursor];

const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4',
      },
    },
  }),
};

type SortableOverlayProps = Omit<
  React.ComponentProps<typeof DragOverlay>,
  'wrapperElement' | 'dropAnimation' | 'style'
> & {
  as?: keyof JSX.IntrinsicElements;
};

export const SortableOverlay: React.FC<SortableOverlayProps> = ({
  children,
  as,
  ...rest
}) => (
  <DragOverlay
    {...rest}
    modifiers={centerUnderMouseModifier}
    dropAnimation={dropAnimationConfig}
    wrapperElement={as}
    style={{ touchAction: 'none', pointerEvents: 'none' }}
    zIndex={index(Options.DND_MOVING_ITEM)}
  >
    {children}
  </DragOverlay>
);
